"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconButtonSkeleton = void 0;
var _common = require("../../common");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const IconButtonSkeleton = () => /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ButtonSkeleton, {
  variant: "circular",
  "data-testid": _common.ICON_BUTTON_SKELETON
});
exports.IconButtonSkeleton = IconButtonSkeleton;
//# sourceMappingURL=IconButtonSkeleton.js.map